/**
 * Which product sections are live in this build (Section 1 of workflows/V5-Section-1-Plan.md).
 * The front door ships before projects and runs exist; the screens that reach into them
 * show a deliberate interim state instead of an error. Flip a flag when its section lands
 * — the interim code paths are the one-line reverts the plan promised.
 *
 * The API this build serves is identity, catalog, billing, admin and health (contracts/src/api).
 * Every flag below names an area whose procedures do not exist yet; while it is off the
 * member tree renders the ComingNext panel for its routes and the shell hides its links,
 * so primary navigation never lands on an error or a not-found page.
 */
export const SECTIONS = {
  /** Projects, the starter wizard, the builder/dashboard and run history: live with Phase F (2026-10-11). */
  projects: true,
  /** Community templates, shared-template links and template shares (Phase 4 of V5-Plan.md). */
  marketplace: false,
  /**
   * The admin dashboard and the admin's own plan switch are live (2026-10-10); the costing
   * sheet under /admin/costing waits for Section 2 (runs and cost records).
   */
  admin: true,
} as const;
